import './polyfill';
import React, {useContext, useEffect} from 'react';
import * as AppContext from './AppContext';
import Layout from './Components/Layout';
// import ActivityIndicator from './Components/ActivityIndicator';
import ActivityIndicator from './Components/Spinner';
import {Font} from '@react-pdf/renderer';
const config = require('./data.json');

if (!config.debug || typeof window === 'undefined') {
  console.log = () => 0;
  console.group = () => 0;
  console.groupEnd = () => 0;
}

Font.register({
  family: 'MiSans',
  src: '/MiSans-Normal.ttf',
});

Font.registerHyphenationCallback((word) => {
  if (word.length === 1) {
    return [word];
  }

  return Array.from(word)
    .map((char) => [char, ''])
    .reduce((arr, current) => {
      arr.push(...current);
      return arr;
    }, []);
});

export function PageContainer(props) {
  return (
    <WithPageContext {...props}>
      <Layout {...props} seo={props.pageContext.seo || {}}>
        {props.children}
      </Layout>
    </WithPageContext>
  );
}

function WithPageContext({pageContext, children}) {
  const app = useContext(AppContext.Context);
  // const {prjConfig} = pageContext;

  useEffect(() => {
    (async () => {
      if (!app.state.user) {
        try {
          app.actions.setAutoLoginLoading(true);
          await app.actions.autoLogin();
          app.actions.getCart();
        } catch (err) {
          console.warn('autologin error', err);
        }
        app.actions.setAutoLoginLoading(false);
      }
    })();
  }, [app.actions, app.state.user]);

  return children;
}

export function AppRoot(props) {
  return (
    <AppContext.Provider {...props}>
      {props.children}
      <ActivityIndicator />
    </AppContext.Provider>
  );
}
